import React from 'react';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import './BibSubTitle.scss';

export class BibSubTitle extends React.PureComponent {
  render() {
    const catalogBibBrief = this.props.catalogBib.get('brief');
    const subTitle = catalogBibBrief.get('subTitle');
    const otherScriptSubTitle = catalogBibBrief.get('otherScriptSubTitle');

    return (
      <div className="cp-bib-subtitle">
        {!!otherScriptSubTitle && <div> {otherScriptSubTitle} </div>}
        {subTitle}
      </div>
    );
  }
}

BibSubTitle.propTypes = {
  catalogBib: catalogBibShape.isRequired
};

export default BibSubTitle;
